import { Reveal, Overline } from "./Reveal";
import { TESTIMONIALS, BUILDERS, SUPPLIERS } from "../lib/site";
import { Star } from "lucide-react";

const Stars = () => (
  <span className="flex gap-1" aria-label="5 out of 5 stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="h-5 w-5 fill-lec-green text-lec-green" />
    ))}
  </span>
);

export const Testimonials = () => (
  <section id="reviews" data-testid="reviews-section" className="scroll-mt-20 bg-white">
    <div className="mx-auto max-w-7xl px-5 py-20 md:px-10 md:py-28">
      <Reveal>
        <Overline>Word on the street</Overline>
        <div className="mt-6 flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <h2 className="max-w-xl font-display text-4xl font-semibold tracking-tight text-lec-ink sm:text-5xl lg:text-6xl">
            Rated <span className="text-lec-ink underline decoration-lec-green decoration-8 underline-offset-8">5.0</span> on Google.
          </h2>
          <div className="flex items-center gap-4" data-testid="google-rating-badge">
            <p className="font-display text-6xl font-semibold text-lec-ink">5.0</p>
            <div>
              <Stars />
              <p className="mt-1 text-xs font-bold uppercase tracking-[0.2em] text-lec-charcoal">
                19 Google Reviews
              </p>
            </div>
          </div>
        </div>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08}>
            <blockquote
              data-testid={`testimonial-card-${i}`}
              className="flex h-full flex-col justify-between border-2 border-lec-ink bg-white p-8 shadow-[6px_6px_0_#111111] transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-[8px_8px_0_#49FF00]"
            >
              <div>
                <Stars />
                <p className="mt-5 text-base leading-relaxed text-lec-ink">“{t.quote}”</p>
              </div>
              <footer className="mt-6 border-t border-lec-line pt-4">
                <p className="font-display text-sm font-semibold text-lec-ink">{t.name}</p>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-lec-charcoal">
                  {t.location}
                </p>
              </footer>
            </blockquote>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-20 border-t border-lec-ink/15 pt-12" data-testid="trusted-by-section">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-lec-charcoal">
            Trusted by local builders
          </p>
          <div className="mt-6 flex flex-wrap items-baseline gap-x-12 gap-y-4">
            {BUILDERS.map((b) => (
              <span key={b} className="font-display text-2xl font-semibold tracking-tight text-lec-ink/45 md:text-3xl">
                {b}
              </span>
            ))}
          </div>
          <p className="mt-10 text-xs font-bold uppercase tracking-[0.25em] text-lec-charcoal">
            Preferred supplier &amp; materials
          </p>
          <div className="mt-6 flex flex-wrap items-baseline gap-x-12 gap-y-4">
            {SUPPLIERS.map((s) => (
              <span key={s} className="font-display text-2xl font-semibold uppercase tracking-tight text-lec-ink/45 md:text-3xl">
                {s}
              </span>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
